import React from "react";

// Create the Footer component
const Footer = () => {
  return (
    <>
      {/* // Add the footer content */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <footer style={{ backgroundColor: "transparent" }}>
          <div className="footer-columns">
            <div className="footer-column">
              <div className="footer-title">Top Destinations</div>
              <ul>
                <li>
                  <a href="/">Hotels in Dublin</a>
                </li>
                <li>
                  <a href="/">Hotels in Galway</a>
                </li>
                <li>
                  <a href="/">Hotels in Killarney</a>
                </li>
                <li>
                  <a href="/">Hotels in London</a>
                </li>
                <li>
                  <a href="/">Hotels in Cork</a>
                </li>
                <li>
                  <a href="/">Hotels in New York</a>
                </li>
                <li>
                  <a href="/">Hotels in Amsterdam</a>
                </li>
                <li>
                  <a href="/">Hotels in Barcelona</a>
                </li>
                <li>
                  <a href="/">Hotels in Paris</a>
                </li>
                <li>
                  <a href="/">Hotels in Belfast</a>
                </li>
                <li>
                  <a href="/">Hotels in Lisbon</a>
                </li>
                <li>
                  <a href="/">Hotels in Edinburagh</a>
                </li>
                <li>
                  <a href="/">Hotels in Rome</a>
                </li>
                <li>
                  <a href="/">Hotels in Dubai</a>
                </li>
                <li>
                  <a href="/">Hotels in Limerick</a>
                </li>
                <li>
                  <a href="/">Hotels in Albufeira</a>
                </li>
                <li>
                  <a href="/">Hotels in Berlin</a>
                </li>
                <li>
                  <a href="/">Hotels in Madrid</a>
                </li>
                <li>
                  <a href="/">Hotels in Prague</a>
                </li>
                <li>
                  <a href="/">Hotels in Waterford</a>
                </li>
                <li>
                  <a href="/">Hotels in Kilkenny</a>
                </li>
                <li>
                  <a href="/">Hotels in Orlando</a>
                </li>
                <li>
                  <a href="/">Hotels in Malaga</a>
                </li>
                <li>
                  <a href="/">Hotels in Vienna</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <div className="footer-title">Top Countries & Regions</div>
              <ul>
                <li>
                  <a href="/">Hotels in Ireland</a>
                </li>
                <li>
                  <a href="/">Hotels in Spain</a>
                </li>
                <li>
                  <a href="/">Hotels in Malta</a>
                </li>
                <li>
                  <a href="/">Hotels in Portugal</a>
                </li>
                <li>
                  <a href="/">Hotels in Maldives</a>
                </li>
                <li>
                  <a href="/">Hotels in Singapore</a>
                </li>
                <li>
                  <a href="/">Hotels in Lanzarote</a>
                </li>
                <li>
                  <a href="/">Hotels in Tenerife</a>
                </li>
                <li>
                  <a href="/">Hotels in Majorca Island</a>
                </li>
                <li>
                  <a href="/">Hotels in Gran Canaria</a>
                </li>
                <li>
                  <a href="/">Hotels in Mayo</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <div className="footer-title">Support & FAQs</div>
              <ul>
                <li>
                  <a href="/payments">Your Booking</a>
                </li>
                <li>
                  <a href="/guestcarddetails">Guest Booking</a>
                </li>
                <li>
                  <a href="/">FAQs</a>
                </li>
                <li>
                  <a href="/">Contact Us</a>
                </li>
                <li>
                  <a href="/">Review a Property</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <div className="footer-title">For Suppliers</div>
              <ul>
                <li>
                  <a href="/">Affiliate with Us</a>
                </li>
                <li>
                  <a href="/">Expedia Partner Solutions</a>
                </li>
                <li>
                  <a href="/">Promote with Us</a>
                </li>
                <li>
                  <a href="/">Travel Agents</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <div className="footer-title">Policies</div>
              <ul>
                <li>
                  <a href="/">Terms & Conditions</a>
                </li>
                <li>
                  <a href="/">Vrbo Terms & Conditions</a>
                </li>
                <li>
                  <a href="/">Privacy</a>
                </li>
                <li>
                  <a href="/">Cookies</a>
                </li>
                <li>
                  <a href="/">Legal information / Contact us</a>
                </li>
                <li>
                  <a href="/">Content Guidelines</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <div className="footer-title">Other Information</div>
              <ul>
                <li>
                  <a href="/">About Us</a>
                </li>
                <li>
                  <a href="/">Careers</a>
                </li>
                <li>
                  <a href="/">Travel Guides</a>
                </li>
              </ul>
            </div>
          </div>
        </footer>
      </div>
      <div
        style={{
          fontSize: "16px",
          width: "70%",
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        
    Disclaimer: This project is a prototype created as part of an undergraduate thesis and project. It is not affiliated with or endorsed by Hotels.com. The design and functionality are inspired by Hotels.com for educational purposes only. For the original Hotels.com website, please visit <a href="https://hotels.com/">https://hotels.com/</a>.


      </div>
    </>
  );
};

export default Footer;
